import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative h-screen min-h-[600px] flex items-center justify-center overflow-hidden" data-id="element-143">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-144">
        <img src="https://cdn.magicpatterns.com/uploads/wj3vyzwaAttZBeThxda77E/1-Capture-Magic-F.-Breidel-Henkel-13-april-2025-2-1536x1024.jpg" alt="Capsin Fong Fong en Madame Jeanette met verse Surinaamse pepers" className="w-full h-full object-cover" data-id="element-145" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/55 to-black/30" data-id="element-146"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-black/40" data-id="element-147"></div>
      </div>

      <div className="relative z-10 text-center px-6 max-w-4xl mx-auto mt-16" data-id="element-148">
        <span className="block text-brand-orange font-medium tracking-[0.2em] uppercase mb-4 animate-fade-in-up" style={{
        animationDelay: '0.1s'
      }} data-id="element-149">
          De Enige Echte Smaakmaker
        </span>
        <h1 className="text-5xl md:text-7xl font-serif font-bold text-white mb-6 leading-tight animate-fade-in-up" style={{
        animationDelay: '0.2s'
      }} data-id="element-150">
          Authentiek Genieten van <br data-id="element-151" />
          <span className="text-brand-red italic" data-id="element-152">Exotische Passie</span>
        </h1>
        <p className="text-lg md:text-xl text-gray-200 mb-10 max-w-2xl mx-auto font-light animate-fade-in-up" style={{
        animationDelay: '0.3s'
      }} data-id="element-153">
          Ontdek de pure, ongetemde smaken van de Madame Jeanette peper.
          Ambachtelijk bereid voor de ware fijnproever.
        </p>

        <div className="animate-fade-in-up" style={{
        animationDelay: '0.4s'
      }} data-id="element-154">
          <Link to="/shop" className="inline-flex items-center gap-2 bg-brand-red text-white px-8 py-4 rounded-full font-medium tracking-wide hover:bg-brand-darkRed hover:shadow-[0_0_20px_rgba(217,56,30,0.4)] hover:scale-105 transition-all duration-300" data-id="element-155">
            Ontdek de Smaak
            <ArrowRight size={20} data-id="element-156" />
          </Link>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce" data-id="element-157">
        <div className="w-[30px] h-[50px] border-2 border-white/50 rounded-full flex justify-center p-2" data-id="element-158">
          <div className="w-1 h-3 bg-white rounded-full" data-id="element-159"></div>
        </div>
      </div>
    </section>;
}